import { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Link } from 'react-router-dom';

class HalCompassInfo extends Component {
    render() {
        const { auth } = this.props;

        // console.log(auth)
        return (

            <div className="d-flex justify-content-center flex-column align-items-center" style={{ height: '100vh' }}>
                <div className="text-left courses-card" style={{ width: '60vh' }}>
                    <div className="middle" style={{ width: "100%" }}>
                        <img alt="" className="text-center" width="100%" src="/image/default.png" />
                    </div>
                    <div style={{ padding: '20px' }}>
                        <h3>HalComPASS</h3>
                        <div className=" row justify-content-center">
                            <div className="title-border"></div>
                        </div>

                        {!auth.uid ? <button className="btn btn-enroll-disable"><i className="fas fa-sign-in-alt"></i>{' '}Login to enroll</button>
                            :
                            <div className="middle"><button className="pushable col-md-12"><Link style={{textDecoration:'none'}} to={"/halcompass/evaluation/"}><span className="shadow"><span className="edge"></span></span><span className="front">Go to Evaluation{' '}<i className="fas fa-arrow-circle-right"></i></span></Link></button></div>}
                    </div>
                    <div className="bg-green programs-btn text-white">
                       
                    </div>
                </div>
            </div>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,

    }
}


export default compose(connect(mapStateToProps))(HalCompassInfo);